import jQuery from 'jquery';

import * as segmentio from 'rp-analytics';
import analyticsPage from '../analyticsPage';

import deviceDetect from './deviceDetect';
import cardPage from './cardPage';

const messageSelectedClass = 'RC-chooseBookieMobile__message--selected';
const popoverSelectedClass = 'RC-chooseBookieMobile--selected';
const bookmakerSelector = '.js-RC-chooseBookieMobile__bookmaker';
const bookmakerSelectedSelector = '.RC-chooseBookieMobile__bookmaker--selected';
const bookmakerSelectedClass = 'RC-chooseBookieMobile__bookmaker--selected';
const buttonSelector = '.js-RC-chooseBookieMobile__button';
const logInSelector = '.js-RC-chooseBookieMobile__accountBtn--logIn';
const registerSelector = '.js-RC-chooseBookieMobile__accountBtn--register';
const linkSelector = '.js-RC-chooseBookieMobile__link';
const overlayClass = 'RC-chooseBookieMobile__overlay';

const configBookieNames = {
    WH_OXI: 'William Hill',
    LADB: 'Ladbrokes',
    PPWR: 'Paddy Power',
    BETFAIR: 'Betfair',
    CORAL: 'Coral',
    SURREY: 'Skybet'
};

export default class ChooseBookie {
    constructor(isOnLoad) {
        this.$template = jQuery('.js-RC-chooseBookieMobile');
        this.$messageSpecific = jQuery('.js-RC-chooseBookieMobile__message--specific');
        this.isOnLoad = isOnLoad;
        this.eventsAreBound = false;
        this.bindEvents = this.bindEvents.bind(this);
    }

    init() {
        if (!deviceDetect.phone() || (this.isOnLoad && jQuery.cookie('chooseBookie'))) {
            this.$template.remove();
            return jQuery.Deferred().resolve();
        }

        this.bindEvents(false);
        const deferred = jQuery.Deferred();
        this.resolvePromise = deferred.resolve;
        if (!this.isOnLoad) {
            this.resolvePromise();
        }
        return deferred.promise();
    }

    bindEvents(isCalledExternally) {
        if (this.isOnLoad || isCalledExternally) {
            this.showLightbox();
        }

        if (!this.eventsAreBound) {
            this.$template
                .on('click', buttonSelector, this.onButtonClick.bind(this))
                .on('click', logInSelector, this.logInBookieHandler.bind(this))
                .on('click', registerSelector, this.registerBookieHandler.bind(this));
            this.eventsAreBound = true;
        }
    }

    showLightbox() {
        const config = {
            cssClass: 'RC-modal_chooseBookieMobile',
            showClose: false,
            autoClose: false,
            overlayCssClass: overlayClass,
        };
        const $overlayNode = jQuery(`.${overlayClass}`);
        const $selectedBookmaker = this.getSelectedBookmakerNode();

        analyticsPage({ 'Choose Your Bookie': 'true' });
        cardPage.removeScroll();

        if (!this.isOnLoad && $selectedBookmaker[0]) {
            this.selectBookmaker($selectedBookmaker);
        }

        if ($overlayNode[0]) {
            $overlayNode.show();
        } else {
            this.$template.rpModalBox(config);
        }
    }

    getSelectedBookmakerNode() {
        const feedName = jQuery.cookie('chooseBookie');

        if (feedName) {
            return jQuery(`${bookmakerSelector}[data-feed="${feedName}"]`);
        }

        return false;
    }

    selectBookmaker($bookmakerChosen) {
        const bookmakerName = $bookmakerChosen.attr('data-bookmaker-name');
        const $bookmakerChosenMessage = jQuery(`.js-RC-chooseBookieMobile__message--${bookmakerName}`);

        if ($bookmakerChosen[0].classList.contains(bookmakerSelectedClass)) {
            return;
        }

        if (!this.$template[0].classList.contains(popoverSelectedClass)) {
            this.$template
                .on('click', linkSelector, this.chooseBookieHandler.bind(this));
            this.$template
                .addClass(popoverSelectedClass);
        }

        jQuery(bookmakerSelector).removeClass(bookmakerSelectedClass);
        this.$messageSpecific.removeClass(messageSelectedClass);
        $bookmakerChosenMessage.addClass(messageSelectedClass);
        $bookmakerChosen.addClass(bookmakerSelectedClass);
    }

    onButtonClick(event) {
        const $bookmakerChosen = jQuery(event.target).closest(bookmakerSelector);

        this.selectBookmaker($bookmakerChosen);
    }

    chooseBookieHandler() {
        const feedName = jQuery(bookmakerSelectedSelector).attr('data-feed');

        if (feedName) {
            jQuery.cookie('chooseBookie', feedName, {
                domain: `.${location.host.split('.').slice(1).join('.')}`,
                path: '/',
                expires: 365
            });

            if (!this.isOnLoad) {
                const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
                    detail: { bookmaker: feedName },
                });
                document.dispatchEvent(betslipEvent);
            }
        }

        this.closeModal();
        this.resolvePromise(feedName);
    }

    closeModal() {
        cardPage.addScroll();

        if (this.isOnLoad) {
            this.$template.rpModalBox('close');
        } else {
            jQuery(`.${overlayClass}`).hide();
        }
    }

    logInBookieHandler() {
        const feedName = jQuery(bookmakerSelectedSelector).attr('data-feed');
        const bookiePosition = parseInt(jQuery(bookmakerSelectedSelector).attr('data-position'), 10);

        this.chooseBookieHandler();
        const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.LOGIN', {
            detail: {
                bookmaker: feedName,
                position: bookiePosition,
            },
        });
        document.dispatchEvent(betslipEvent);
    }

    registerBookieHandler() {
        const feedName = jQuery(bookmakerSelectedSelector).attr('data-feed');
        const bookiePosition = parseInt(jQuery(bookmakerSelectedSelector).attr('data-position'), 10);
        const bookieName = configBookieNames[feedName];
        const config = {
            [segmentio.TRAIT_BOOKMAKER]: bookieName,
            [segmentio.TRAIT_LOCATION]: 'Choose Your Bookie',
            [segmentio.TRAIT_POSITION]: bookiePosition,
        };

        segmentio.trackBookmakerRegister(config);
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/chooseBookie.js